import React from "react";
import styled from "styled-components";
import Card from "../UI/card";
import SectionWrapper from '../UI/SectionWrapper';

import maintanance from '../../../Assets/services/maintanance-and-support.jpg';
import enterprise from '../../../Assets/services/enterprise.jpg'
import legacy from '../../../Assets/services/legacy.jpg';
import appIntegration from '../../../Assets/services/app-integration.jpg';
import techConsult from '../../../Assets/services/technology-consulting.jpg';
import techStack from '../../../Assets/services/tech-stack.png';


const cards = [
  {
    title: "Enterprise Level Application Development",
    label: "Research Report",
    image: enterprise,
    description:`Our team consists of highly skilled developers with extensive experience in enterprise-level application development. ###
    We collaborate closely to understand the business processes, challenges, and goals which enables to develop a comprehensive roadmap and architecture that forms the foundation for a robust and future-proof application. We leverage the latest technologies and follow industry-standard coding practices to create scalable and secure applications that meet specific needs of client.###
    Our solutions are tailored to the specific requirements, ensuring that the application aligns perfectly with business processes. We design applications with scalability, allowing them to grow and adapt as your business evolves.`,
    link: "/in-en/insights/data-ai/front-runners-guide-scaling-ai",
  },
  {
    title: "Thought Leadership and Technology Consulting",
    label: "Research Report",
    image: techConsult,
    description: `In today's rapidly evolving technological landscape, organisations face the constant challenge of staying ahead of the curve.###
    By leveraging our thought leadership and technology consulting services, you can gain a trusted partner who understands the challenges and aspirations of the industry. We collaborate to drive innovation and leverage emerging technologies, empowering us to achieve sustainable growth and competitive advantage in the ever-evolving marketplace.###
    With a deep understanding of various technologies, platforms, and vendors, we assist in evaluating and selecting the right technology solutions that best fit client requirements, ensuring optimal performance, scalability, and future-proofing.`,
    link: "/in-en/insights/supply-chain/making-autonomous-supply-chains-real",
  },
  {
    title: "Legacy Application Empowerment",
    label: "Research Report",
    image: legacy,
    description: `
    The legacy application comes with its own risks and expensive maintenance costs.###
    Modernise your Legacy application through transformation to improve its functionality, maintainability, performance, and user experience while preserving its core business logic.###
    With our cutting-edge tools, you can automate the synchronisation process, enabling near-real-time data updates. By staying in sync with the latest data, you can make informed decisions faster, respond swiftly to market changes, and gain a competitive edge in your industry.###
    Legacy application support in VB.Net, VC++, C#, .Net Framework, .Net Core, MS SQL Server, MySQL, MS Access etc.`,
    link: "/in-en/insights/supply-chain/making-autonomous-supply-chains-real",
  },
  {
    title: "Application Integration",
    label: "Research Report",
    image: appIntegration,
    description: `
    We empower your organisation to connect, integrate, and optimise your software ecosystem for enhanced collaboration and productivity.###
    Start by thoroughly analysing the client's existing software infrastructure and their specific integration requirements. Understand their business goals, processes, and pain points to identify opportunities for integration.###
    We specialise in providing top-notch software integration services to businesses of all sizes. Our team of experts is dedicated to helping seamlessly integrate software systems, streamlining operations, and maximising efficiency.`,

    link: "/in-en/insights/supply-chain/making-autonomous-supply-chains-real",
  },
  {
    title: "Application Maintenance and Support",
    label: "Research Report",
    image: maintanance,
    description: `
    Our experienced support team possesses deep technical expertise to diagnose and troubleshoot application-related issues efficiently. We employ industry best practices to quickly identify the root cause of problems and implement effective solutions, minimising downtime and maximising productivity.###
    Our experts’ analyses applications performance metrics, identify bottlenecks, and optimize system resources to enhance speed, reliability, and scalability. We fine-tune applications to deliver an exceptional user experience, even during peak usage periods.
   `,
    link: "/in-en/insights/supply-chain/making-autonomous-supply-chains-real",
  },
  {
    title: "Technology Stack",
    label: "Research Report",
    image: techStack,
    description: `
    * .NET Core 8.0 C#/Node.js ###
    * MS SQL Server/Postgres SQL/MongoDB SQL for Database ###
    * Angular/React for frontend development ###
    * Microsoft Azure/AWS Infrastructure ###
    * Microservice Architecture – Support for Scaling ###
    * Kubernetes Service – Approach for deployment of largescale applications ###
    * AI/ML - Google Gemini, OpenAI GPT ###
    * Message Queue - ESB/RabbitMQ/AWS SQS ###
    * Cache - Redis ###
    * Search - Elasticsearch ###
   `,
    link: "/in-en/insights/supply-chain/making-autonomous-supply-chains-real",
  },
];

const Grid = styled.div`
  display: grid;
  gap: 24px;
    /* Default: 1 column (mobile) */
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(1, 1fr); /* Tablet */
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr); /* tab */
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, 1fr); /* tab */
  }
`;


const Services = () => {
  return (
    <SectionWrapper heading="SERVICES">
        <Grid>
        {cards.map((card, index) => (
            <Card key={index} {...card} />
        ))}
        </Grid>
    </SectionWrapper>
  );
};

export default Services;
